export const getContentDispositionFileName = (
  contentDisposition: string
): string | null => {
  // First try to match RFC 5987 encoded filename (filename*=UTF-8''...)
  const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (rfc5987Match && rfc5987Match[1]) {
    return decodeURIComponent(rfc5987Match[1]);
  }

  // Fall back to standard filename parameter
  const fileNameMatch = contentDisposition.match(
    /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  );

  const fileName = fileNameMatch?.[1]?.replace(/['"]/g, '') || null;

  // Per RFC 6266, filename= must only contain ASCII printable characters.
  // Non-ASCII indicates a corrupted or improperly encoded upstream header
  // (e.g. raw UTF-8 bytes misinterpreted as Latin-1). Return null so callers
  // fall back to their defaultFileName from metadata.
  if (fileName && /[^\u0020-\u007E]/.test(fileName)) {
    return null;
  }

  return fileName;
};

export const getContentDispositionFileExtension = (
  contentDisposition: string
): string | null => {
  const fileName = getContentDispositionFileName(contentDisposition);

  if (!fileName || !fileName.includes('.')) {
    return null;
  }

  return fileName.split('.').pop() ?? null;
};
